const FormResources = {

    form_data:{
        room_type_id:       [],
        // inspection_type_id: '',
        name:               '',
        description:        '',
        instruction:        '',
        status: true
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'switch',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Active:',
            model_name: 'status',
            ref:        'status_input',
            ref_alt:    'status_input_alt',
            required:   false,
        },
        // {
        //     css_class:  'col-md-6',
        //     type:       'select',
        //     maxlength:  '',
        //     disabled:   false,
        //     step:       '',
        //     name:       'Inspection types:',
        //     model_name: 'inspection_type_id',
        //     ref:        'inspection_type_id_input',
        //     ref_alt:    'inspection_type_id_input_alt',
        //     required:   true,
        // },
        {
            css_class:  'col-md-6',
            type:       'textarea',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Description:',
            model_name: 'description',
            ref:        'description_input',
            ref_alt:    'description_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-6',
            type:       'textarea',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Instruction:',
            model_name: 'instruction',
            ref:        'instruction_input',
            ref_alt:    'instruction_input_alt',
            required:   false,
        },
    ],

    status_options: [
        {
            id: 3, 
            name: 'All'
        },
        {
            id: 1, 
            name: 'Active'
        },
        {
            id: 0, 
            name: 'Inactive'
        },
    ]

}

export default FormResources;